import * as React from 'react';

export interface SaveOrderProps {
    buttonCss?: string;
    buttonText?: string;
    onAction(): void;
}

export interface SaveOrderState {
    isSaving: boolean;
}

export class SaveOrder extends React.Component<SaveOrderProps, SaveOrderState> {
    constructor(props: SaveOrderProps) {
        super(props);

        this.state = {
            isSaving: false
        }
    }

    static defaultProps = {
        buttonCss: 'button',
        buttonText: 'Spara'
    }

    doAction = () => this.props.onAction();

    public render() {
        const { buttonCss, buttonText } = this.props

        return (
            <button className={buttonCss} onClick={this.doAction}>
                {buttonText}
            </button>
        );
    }
}
